import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/file-video': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M369.9 97.9c7.8 7.8 14.1 23 14.1 33.9v332.1c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48h204.1c11 0 26.2 6.3 33.9 14.1zM332.1 128l-76.1-76.1v76.1h76.1zM48 464h288v-288h-104c-13.3 0-24-10.7-24-24v-104h-160v416zM276.7 252.7c10-10 27.3-3 27.3 11.3v112c0 14.3-17.3 21.3-27.3 11.3l-52.7-52.7v37.4c0 11-9 20-20 20h-104c-11 0-20-9-20-20v-104c0-11 9-20 20-20h104c11 0 20 9 20 20v37.4z'
      }
    ]
  }
})
